if (typeof window !== 'undefined') {
  require('xtend-library/src/addons/animation/mouse-follow.js')
  require('xtend-library/src/addons/animation/propagate-interaction.js')
  require('xtend-library/src/addons/animation/ripple.js')
  require('xtend-library/src/addons/animation/scroll-to-anchor.js')
  require('xtend-library/src/addons/form/textarea-autosize.js')
  require('xtend-library/src/addons/group/expand.js')
  require('xtend-library/src/addons/group/number.js')
  require('xtend-library/src/addons/slider/navigation-sides.js')
  require('xtend-library/src/addons/structure/google-locator.js')
  require('xtend-library/src/addons/structure/infinite-scroll.js')
  require('xtend-library/src/addons/structure/jump-to-content.js')
  require('xtend-library/src/addons/test.js')
  require('xtend-library/src/addons/toggle/multilevel.js')
}
